import React from 'react';
import { useTranslation } from '@lt/localization';
import { ButtonTs, Link } from '@lt/components';
import { HOTEL_CARD_EXPLORE_BUTTON } from '../../constants';

import styles from './hotelCardExploreButton.module.css';

type HotelCardExploreButtonProps = {
  href: string;
  isCardHovered: boolean;
  openInCurrentTab: boolean;
  isHotelOnly: boolean;
};

const HotelCardExploreButton: React.FC<HotelCardExploreButtonProps> = ({
  href,
  isCardHovered,
  openInCurrentTab,
  isHotelOnly,
}) => {
  const { t } = useTranslation();

  return (
    <Link
      href={href}
      target={openInCurrentTab ? '_self' : '_blank'}
      data-testid={HOTEL_CARD_EXPLORE_BUTTON}
      className={styles.link}
    >
      <ButtonTs
        className={`${styles.button} ${
          !isCardHovered ? styles.buttonNotHovered : ''
        }`}
        variant="primary"
      >
        {t('hotelcard.card.button', {
          context: isHotelOnly ? 'hotel' : 'package',
        })}
      </ButtonTs>
    </Link>
  );
};

export default HotelCardExploreButton;
